import { useEffect } from "react";

import { KeyTypes } from "./types";

export const useKeyPress = ({
  key = "Enter",
  ...props
}: {
  action: any;
  key?: KeyTypes;
}) => {
  useEffect(() => {
    const handleKeyDown = (event: any) => {
      if (event.code == key) {
        if (props.action) {
          props.action();
        }
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [props]);
};
